<template>
<Modal v-model="modal"  width="750">
    <div id="pdfDom" ref="imageDom"> 
    <Row>
        <Col span="24">
          
                <div class="reportTitle">
                   {{reportTitle}}
                </div>
                <div class="subtitle"> {{curday}}</div>
               <div class="subtitle"> <img _ngcontent-dak-c50="" class="red-line" src="../../../assets/img/xxian.png"></div>
            <Row >
                    <Col span="23" offset=1 style="font-size:22px;font-weight:blod"><p >一、本期导读</p></Col> 
              </Row><br/>  
              <Row >     
                   <Col span="23" offset=1 style="font-size:16px;"><p > 
                       &nbsp;&nbsp;&nbsp;&nbsp; <span class="exp">{{sectionday}}</span>，
                      省级层面针对演出（涉外人员演出）、票务、网络文化产品和在线旅游产品持续开展网络巡查。</p></Col>
               
            </Row><br/>
             <Row >
                    <Col span="23" offset=1 style="font-size:22px;font-weight:blod"><p >二、旅游产品巡查分析</p></Col> 
             </Row><br/>  
              <Row > 
                    <Col span="23" offset=1 style="font-size:16px;"><p >
                        &nbsp;&nbsp;&nbsp;&nbsp;巡查陕西境内旅游和陕西出境旅游网站<span class="exp">{{travelWeb}}</span>个，
                        共巡查陕西旅游产品<span class="exp">{{travelProduct}}</span>个。
                        其中，本省经营单位省内旅游产品<span class="exp">{{travelProvince}}</span>个，
                        以及出境旅游产品<span class="exp">{{travelOverseas}}</span>个。
                        涉嫌低价游产品<span class="exp">{{minPrince}}</span>个，
                        涉嫌未经许可经营旅行社业务<span class="exp">{{travelNolicence}}</span>个。
                        </p>
                        <p >
                        &nbsp;&nbsp;&nbsp;&nbsp;巡查省内旅游微信公众号合计<span class="exp">{{a_2_2_1}}</span>个、
                        公众号文章合计<span class="exp">{{a_2_2_2}}</span>篇，涉及本省旅行社经营单位
                            <span class="exp">{{a_2_2_3}}</span>家，未发现涉嫌未经许可经营旅行社业务。
                        </p>  
                        <p >
                         &nbsp;&nbsp;&nbsp;&nbsp;巡查出境游公众号合计<span class="exp">{{a_2_3_1}}</span>个、
                            公众号号文章合计<span class="exp">{{a_2_3_2}}</span>篇，均未涉及本省旅行社经营单位。
                        </p>   
                        <p >
                         &nbsp;&nbsp;&nbsp;&nbsp;巡查本省在<span class="exp">{{a_2_4_1}}</span>家主流票务网站中票务
                            和演出信息<span class="exp">{{a_2_4_2}}</span>条，
                         本省演出和售票单位<span class="exp">{{a_2_4_3}}</span>家。
                         巡查省内“脱口秀”演出活动<span class="exp">{{a_2_4_4}}</span>场。
                         发现涉嫌未经许可经营演出票务活动单位<span class="exp">{{a_2_4_5}}</span>家。
                        </p>  
                         <p >
                         &nbsp;&nbsp;&nbsp;&nbsp;巡查大众点评中本省酒吧<span class="exp">{{a_2_5_1}}</span>家，未发现涉嫌外籍人员演出酒吧。
                        </p>  
                        <p >
                         &nbsp;&nbsp;&nbsp;&nbsp;涉嫌“性暗示、欺凌暴力、血腥”网络动漫及网络音乐巡查，
                         对本省<span class="exp">{{a_2_6_1}}</span>个本省网络文化产品经营单位网站，未发现涉嫌发布违规网络文化产品经营单位。
                        </p>  
                         <p >
                         &nbsp;&nbsp;&nbsp;&nbsp;涉嫌民族宗教有害内容的巡查，
                         对本省<span class="exp">{{a_2_7_1}}</span>个本省网络文化产品经营单位网站，未发现涉嫌发布民族宗教有害内容。
                        </p> 
                        <p >
                         &nbsp;&nbsp;&nbsp;&nbsp;涉嫌民族宗教有害内容的巡查，对本省<span class="exp">{{a_2_8_1}}</span>所高校贴吧巡查，
                         未发现涉嫌发布民族宗教有害内容。
                        </p> 
                         <p >
                         &nbsp;&nbsp;&nbsp;&nbsp;对“书海”、“天宝云阅”两家本省文学网站巡查，未发现“耽美”小说作品。
                        </p> 
                        <p v-show="txtcontent!=''">&nbsp;&nbsp;&nbsp;&nbsp;{{txtcontent}}</p>
                          
                    </Col>
               
            </Row><br/>
            <Row >
                    <Col span="23" offset=1 style="font-size:22px;font-weight:blod"><p>三、确认线索概述</p></Col> 
             </Row><br/>  
              <Row > 
                    <Col span="23" offset=1 style="font-size:16px;">
                    <p>1、涉嫌低价游产品<span class="exp">{{a_3_1_number}}</span>个</p></Col>
              </Row><br/>  
               <Row >
                
                <Col span="22" offset=1>
                        <Table :loading="loading" 
                               border ref="table" stripe :columns="columns1" :data="listData1">
                           
                        </Table>
                 </Col>
                
            </Row>
            <br/> 
             <Row > 
                    <Col span="23" offset=1 style="font-size:16px;">
                    <p>2、涉嫌未经许可经营旅行社业务<span class="exp">{{a_3_2_number}}</span>个</p></Col>
              </Row><br/>  
              <Row >
                
                <Col span="22" offset=1>
                        <Table :loading="loading" 
                               border ref="table" stripe :columns="columns2" :data="listData2">
                           
                        </Table>
                 </Col>
                
            </Row>
            <br/> 
             <Row > 
                    <Col span="23" offset=1 style="font-size:16px;">
                    <p>3、涉嫌未经许可经营演出票务活动单位<span class="exp">{{a_3_3_number}}</span>家</p></Col>
              </Row><br/>  
              <Row >
                
                <Col span="22" offset=1>
                        <Table :loading="loading" 
                               border ref="table" stripe :columns="columns3" :data="listData3">
                           
                        </Table>
                 </Col>
                
            </Row>
            <br/> 
            <Row > 
                    <Col span="23" offset=1 style="font-size:20px;"><p>四、图表展示</p></Col>
              </Row>
               <Row > 
                       <Col span="16"  offset=3> <div id="myGl"  ref="myGl"   style=" left:5%;" :class="{'active':isActive == -1}"></div></Col> 
              </Row><br/>
               <Row > 
                       <Col span="16" offset=3> <div id="mybar"  ref="mybar"   style=" left:5%;" :class="{'active':isActive == -1}"></div></Col> 
              </Row><br/>
            
        </Col>
    </Row>
    <Row>
          
                 <Col span="10" offset=7>
                    <div v-for="(item, index) in imgList" :key="index">
                    <div  style="float:left;margin:10px;">
                        <img  :src="`${item.url}`"  width="300">
                    </div>
                </div>
                </Col>
    </Row>
    <br/><br/>
    </div>
         <div slot="footer" style="text-align:center;margin-top:30px;">
                  <!--<Button type="info"  size="large" v-print="'#printContent'" >打印</Button>  -->
                  <Button type="info"   size="large" @click="getPdf" >下载报告</Button>
            </div>
        </Modal>
    
</template>

<script>

   
    import html2canvas from "html2canvas";
    import dateutil from '@/utils/date.js'
    import echarts from 'echarts'
    import ZgUpload from '@/components/upload/ZgUpload';
    export default {
        components: {
             ZgUpload,
        },
        methods: {
            openModal(title,id) {
                  this.reportTitle =title
				  this.modal = true
                  this._id =id
                  this.loadPage()
			  },

           
            
            loadPage() {
                this.loading = true
               let url = `/api/report/get_one_word_report`
              
               this.req({
                    url: url,
                    method: 'post',
                    data:{
                      _id: this._id
                     
                    }
                }).then(resp => {                 
                     let _date=resp.data.data.base_data
                     if(_date==''){
                        this.$Message.info('数据正在生成请稍后')
                        setTimeout(this.loadPage, 20000 )
                     }else{
                      this.loading;
                     this.curday =resp.data.data.createTime
                     this.sectionday = _date.a_1_1
                     this.travelWeb = _date.a_2_1_1
                     this.travelProduct = _date.a_2_1_2
                     this.travelProvince = _date.a_2_1_3
                     this.travelOverseas = _date.a_2_1_4
                     this.minPrince = _date.a_2_1_5
                     this.travelNolicence = _date.a_2_1_6
                     this.a_2_2_1 = _date.a_2_2_1
                     this.a_2_2_2 = _date.a_2_2_2
                     this.a_2_2_3 = _date.a_2_2_3
                     this.a_2_3_1 = _date.a_2_3_1
                     this.a_2_3_2 = _date.a_2_3_2
                     this.a_2_4_1 = _date.a_2_4_1
                     this.a_2_4_2 = _date.a_2_4_2
                     this.a_2_4_3 = _date.a_2_4_3
                     this.a_2_4_4 = _date.a_2_4_4
                     this.a_2_4_5 = _date.a_2_4_5
                     this.a_2_5_1 = _date.a_2_5_1
                     this.a_2_6_1 = _date.a_2_6_1
                     this.a_2_7_1 = _date.a_2_7_1
                     this.a_2_8_1 = _date.a_2_8_1
                     this.a_3_1_number = _date.a_3_1.number;
                     this.a_3_2_number = _date.a_3_2.number;
                     this.a_3_3_number = _date.a_3_3.number;
                     this.listData1 = _date.a_3_1.data;
                     this.listData2 = _date.a_3_2.data;
                     this.listData3 = _date.a_3_3.data;
                     this.txtcontent = resp.data.data.other_data.txtcontent
                     this.imgList = resp.data.data.other_data.img
                     this.pieList =_date.a_4_1
                     this.barList =_date.a_4_2

                     this.initPie()
                     this.initBar()
                    
                     }
                     
                    this.loading = false
                }).catch(error => {
                   this.$Message.error('服务器错误:' + error)
            	})
              
            },
//饼状图
             	initPie(){    
                    let  seriesData=[];
                    if(this.pieList.length>0){
                       for(let i = 0; i < this.pieList.length; i++){
                            seriesData.push({
                                    'name':this.pieList[i]._id,
                                    'value':this.pieList[i].count
                                    });         
                                
                        } 
                    }
                         
                        let querymyGl = this.$echarts.init(this.$refs.myGl)
                        let  option = {
                                legend: {
                                    top: 'bottom'
                                },
                                 title: {
                                        text: '演出票务巡查统计',
                                        left: 'center'
                                    },
                                series: [
                                    {
                                    name: '演出票务巡查统计',
                                    type: 'pie',
                                     radius: '55%',
                                     center: ['50%', '50%'],
                                    itemStyle: {
                                        borderRadius: 2
                                    },
                                    data:seriesData
                                    }
                                ]
                                };
                            
                        
                            if (option && typeof option === "object") {
                                querymyGl.setOption(option, true);
                            } 
                        
                        
                        
                    },
            //柱状图
             initBar(){ 
                let  seriesData=[];
                    if(this.barList.length>0){
                       for(let i = 0; i < this.barList.length; i++){
                        
                            seriesData.push({
                                    'name':this.barList[i]._id,
                                    'type':'bar',
                                    'data':[this.barList[i].count]
                                    });         
                                
                        } 
                    }            
                let myGl = this.$echarts.init(this.$refs.mybar)               
                let	option = {
                        title: {
                            text: '旅游产品巡查数据统计图',
                            textStyle: {
                            color: '#000',
                            fontSize: 18,   
                            },
                            left:'center'
                        },
                        legend: {
                            type: 'plain',  // 图列类型，默认为 'plain'
                            bottom: '1%',  // 图列相对容器的位置 top\bottom\left\right
                            itemWidth: 10,
                            itemGap: 5,
                            textStyle: {  // 图列内容样式
                                color: '#000',  // 字体颜色
                                fontSize:10
                                },					
                            
                        },
                        tooltip: {
                                trigger: 'axis',
                                axisPointer: {
                                  type: 'shadow' 
                                }
					   },
                        xAxis: {
                            type: 'category',
                            data:   [],//
                            axisLine: {       // 坐标轴 轴线
                            show: true,  // 是否显示					 
                            lineStyle: {
                                color: '#000',
                                width: 1,
                                type: 'solid'
                            }
                            },
                            splitLine:{
                                show:false
                            }
                            
                        },
                        
                        yAxis: {
                            type: 'value',
                            axisLine: {       // 坐标轴 轴线
                            show: true,  // 是否显示					 
                            
                            },
                            splitLine:{
                                show:false
                            }
                        },
                        grid:{
                                top:'10%',//距上边距
                                left:'1%',//距离左边距
                                right:'0%',//距离右边距
                                bottom:'25%',//距离下边距
                                containLabel:true
                            },
                        tooltip: {
                            trigger: 'axis',
                            axisPointer: { // 坐标轴指示器，坐标轴触发有效
                                type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
                            },
                            // 鼠标移入条形图提示层文字的自定义
                            formatter (params) {
                                let relVal = '' //params[0].name
                                for (var i = 0, l = params.length; i < l; i++) {
                                
                                relVal +=   params[i].seriesName + ' : ' + params[i].value 
                                }
                                return relVal
                            }

                            },
                        series: seriesData
                    };                    
                
                    if (option && typeof option === "object") {
                        myGl.setOption(option, true);
                    } 
           
      },
             
             //
         
          
          
          
           
        
        },
        mounted: function () {
        // this.loadPage()
        },
        data() {
            return {
                listData1: [],
                listData2: [],
                listData3: [],
                imgList:[],
                pieList:[],
                barList:[],
                isActive:-1,
                txtcontent:'',
                color :['#3FC3E3','#47BAC1','#AE69AF','#80848C','#F8E71C','#4FE2C3','#FDA821','#6EB5D7','#E6F1C9','#E7ECF4'],
                loading: true,
                modal: false,
                texShow: false,
                title: '报告页',
                sectionday: '',
                reportTitle:'',
                travelWeb:'0',
                travelProduct:'0',
                travelProvince:'0',
                travelProduct:'0',
                travelOverseas:'0',
                travelNolicence:'0',
                minPrince:'0',
                a_2_2_1:'0',
                a_2_2_2:'0',
                a_2_2_3:'0',
                a_2_3_1:'0',
                a_2_3_2:'0',
                a_2_4_1:'0',
                a_2_4_2:'0',
                a_2_4_3:'0',
                a_2_4_4:'0',
                a_2_4_5:'0',
                a_2_5_1:'0',
                a_2_6_1:'0',
                a_2_7_1:'0',
                a_2_8_1:'0',
                a_3_1_number:0,
                a_3_2_number:0,
                a_3_3_number:0,
                content:'',
                curday: dateutil.computedDate(new Date(new Date().setDate(new Date().getDate())).toLocaleDateString()),
                columns1: [{
                        type: 'index',
                        title: '序号',
	                    width: 60,
	                    align: 'center',
                    },
                    {
                        title: '标题',
                        key: 'title' ,
                        align: 'center',
                         render:(h,params)=>{
                             let text='<a href='+params.row.url+' target="_blank" style="color:#000;">'+params.row.title+'</a>'
                             return h("div",{domProps:{
                                innerHTML:`<div >`+text+`</div>`
                            }})
                         }
                    }, 
           			 {
                        title: '链接地址',
                        key: 'url' ,
                        align: 'center',
                    },
                    {
                        title: '来源',
                        key: 'source' ,
                        align: 'center',
                    }, {
                        title: '类型',
                        key: 'type' ,
                        align: 'center',
                    }, {
                        title: '价格',
                        key: 'minPrice' ,
                        align: 'center',
                    },  {
                        title: '供应商',
                        key: 'supplierInfo' ,
                        align: 'center',
                    }, {
                        title: '是否有经营许可证',
                        key: 'license' ,
                        align: 'center',
                    }
                ],
                  columns2: [{
                        type: 'index',
                        title: '序号',
	                    width: 60,
	                    align: 'center',
                    },
                    {
                        title: '标题',
                        key: 'title' ,
                        align: 'center',
                         render:(h,params)=>{
                             let text='<a href='+params.row.url+' target="_blank" style="color:#000;">'+params.row.title+'</a>'
                             return h("div",{domProps:{
                                innerHTML:`<div >`+text+`</div>`
                            }})
                         }
                    }, 
           			 {
                        title: '链接地址',
                        key: 'url' ,
                        align: 'center',
                    },
                    {
                        title: '来源',
                        key: 'source' ,
                        align: 'center',
                    }, {
                        title: '类型',
                        key: 'type' ,
                        align: 'center',
                    }, {
                        title: '价格',
                        key: 'minPrice' ,
                        align: 'center',
                    }, {
                        title: '供应商',
                        key: 'supplierInfo' ,
                        align: 'center',
                    }, {
                        title: '是否有经营许可证',
                        key: 'license' ,
                        align: 'center',
                    }
                ],
                  columns3: [{
                        type: 'index',
                        title: '序号',
	                    width: 60,
	                    align: 'center',
                    },
                    {
                        title: '标题',
                        key: 'title' ,
                        align: 'center',
                         render:(h,params)=>{
                             let text='<a href='+params.row.url+' target="_blank" style="color:#000;">'+params.row.title+'</a>'
                             return h("div",{domProps:{
                                innerHTML:`<div >`+text+`</div>`
                            }})
                         }
                    }, 
           			 {
                        title: '链接地址',
                        key: 'url' ,
                        align: 'center',
                    },
                    {
                        title: '来源',
                        key: 'source' ,
                        align: 'center',
                    }, {
                        title: '类型',
                        key: 'type' ,
                        align: 'center',
                    }, {
                        title: '价格',
                        key: 'minPrice' ,
                        align: 'center',
                    },  {
                        title: '供应商',
                        key: 'supplierInfo' ,
                        align: 'center',
                    }, {
                        title: '是否有经营许可证',
                        key: 'license' ,
                        align: 'center'
                    }
                ],

               
            }
        },

    }
</script>



<style lang='less'   scoped>
.reportTitle{
    width: 100%;
    min-height:40px;
    margin: 0 auto;
    text-align: center;
    font-size: 26px;
    color:red
}
.subtitle{
  width: 100%;
    height:35px;
    margin: 0 auto;
   text-align: center;
}
.red-line{width:710px;vertical-align: middle;
    border-style: none;}
    .demo-tabs-style1 > .ivu-tabs-card > .ivu-tabs-content {
        height: 100%;
        margin-top: -16px;
    }

    .demo-tabs-style1 > .ivu-tabs-card > .ivu-tabs-content > .ivu-tabs-tabpane {
        background: #fff;
        padding: 16px;
    }

    .demo-tabs-style1 > .ivu-tabs.ivu-tabs-card > .ivu-tabs-bar .ivu-tabs-tab {
        border-color: transparent;
    }

    .demo-tabs-style1 > .ivu-tabs-card > .ivu-tabs-bar .ivu-tabs-tab-active {
        border-color: #fff;
    }
    .table1{
        text-align:center;border:1px #000;margin-bottom: 20px; font-size: 14px;
    }
    .table1 tr{height: 40px;}
   .title{
        font-size: 30px;
        font-weight: 600;
    }
    @page{
      size: auto A4 landscape;
      margin: 0mm auto; 
    }
    .chart{
        min-height:260px;
        width: 100%;
    }
     .active{
        width: 500px;
        min-height: 500px;
    }
    .exp{text-decoration:underline;color: red;}
</style>








// WEBPACK FOOTER //
// src/pages/platform/createReport/CreateReportSee.vue